const translations = {
  app: {
    default: 'Standaard',
    company: 'Afosto',
    title: 'Fulfilment',
    yes: 'Ja',
    no: 'Nee',
    unauthorizedMessage: 'Je hebt geen toestemming om deze informatie in te zien.',
    searchBar: {
      search: {
        label: 'Zoeken',
        placeholder: 'Zoeken',
      },
    },
    switchedTenant: {
      title: 'Organisatie gewisseld',
      message:
        'Je bent van organisatie gewisseld in een ander venster. Klik hieronder op de "Ok" knop, om in het huidige venster te wisselen naar deze organisatie.',
      actions: {
        ok: 'Ok',
      },
    },
    dock: {
      iam: 'Dashboard',
      spl: 'Spooler',
      cnt: 'Files',
      mes: 'Berichten',
      dashboard: 'Afosto',
      notifications: 'Notificaties',
      fulfilment: 'Fulfilment',
      picker: 'Picker',
      spooler: 'Spooler',
      products: 'Producten',
      user: 'Gebruiker',
      wms: 'WMS',
      rel: 'Contacten',
      order: 'Orders',
      messaging: 'Berichten',
      userMenu: {
        signOut: 'Uitloggen',
        selectTenant: 'Selecteer een organisatie',
        searchTenants: {
          placeholder: 'Zoeken naar organisaties',
        },
        addNewTenant: {
          title: 'Nieuwe organisatie toevoegen',
          subtitle: 'Vraag toegang aan voor een nieuwe organisatie',
        },
        emptyTenants: 'Geen organisaties gevonden',
        subtenantForm: {
          description:
            'Voer het e-mailadres in van de organisatie waar je toegang toe wilt verkrijgen.',
          fields: {
            signee: 'E-mailadres',
          },
          actions: {
            cancel: 'Annuleren',
            sent: 'Verstuur verzoek',
          },
        },
        switchTenant: 'Switch organisatie',
      },
      notificationsMenu: {
        none: 'Geen notificaties',
        all: 'Alle notificaties',
      },
    },
    navigation: {
      main: {
        fulfilmentLocations: 'Fulfilment locaties',
        shipments: 'Verzendingen',
        handlingLists: 'Werklijsten',
        parcels: 'Pakketten',
        parkParcels: 'Pakketten parkeren',
        packing: 'Inpakken',
        moveInventory: 'Voorraad verplaatsen',
        shippingMethods: 'Verzendmethoden',
        settings: 'Instellingen',
      },
    },
    feedback: {
      mobileOnly: 'Deze pagina wordt alleen ondersteund op mobiele schermen.',
    },
  },
  deliveryDuringOptions: {
    daytime: 'Overdag',
    morning: 'In de ochtend',
    afternoon: 'In de middag',
    evening: 'In de avond',
  },
  contactInformation: {
    title: 'Contact',
    personalInformation: 'Persoonlijke informatie',
    phoneNumber: 'Telefoonnummer',
    organisation: 'Organisatie',
    vatNumber: 'BTW-nummer',
    emptyMessage: 'Geen contact informatie',
  },
  batchForm: {
    steps: {
      dataset: 'Gegevens',
      action: 'Actie',
      mapping: 'Kolom selectie',
      validation: 'Validatie',
    },
    feedback: {
      batchStarted: 'Batch wordt uitgevoerd',
      batchNotStarted: 'Batch kan niet worden uitgevoerd',
      batchSaved: 'Batch opgeslagen',
      batchNotSaved: 'Batch kan niet worden opgeslagen',
    },
  },
  batchActionForm: {
    action: 'Actie',
    batchReference: 'Batch referentie',
    actions: {
      positionUpdate: {
        columns: {
          location: 'Locatie',
          locationId: 'Locatie',
        },
      },
      positionExport: {
        columns: {
          locationId: 'Locatie',
        },
      },
    },
  },
  batchMappingForm: {
    mappingError: 'De volgende kolommen zijn verplicht om te selecteren: {columns}',
  },
  batchActions: {
    positionUpdate: 'Fulfilment posities bijwerken',
    positionExport: 'Fulfilment posities exporteren',
  },
  batchValidation: {
    validationFailed: 'Je bulkactie bevat de volgende foutmeldingen',
    validationSucceeded: 'Je bulkactie bevat geen fouten en kan nu worden uitgevoerd',
    validatingMessage: 'Je bulkactie wordt momenteel gevalideerd.',
  },
  batchesGrid: {
    previewActions: {
      confirm: 'Bevestigen',
      validate: 'Valideren',
    },
  },
  batchColumns: {
    sku: 'SKU',
    position: 'Positie',
  },
  datasetForm: {
    type: 'Type gegevens',
    reference: 'Referentie gegevens',
    firstRowAsColumns: 'Eerste regel als kolomnamen',
    dataset: 'Kies gegevens',
    loadingMessage: 'Gegevens koppelen aan dataset',
    types: {
      file: 'Bestand (CSV)',
      spreadsheet: 'Spreadsheet',
      existingDataset: 'Bestaande gegevens',
    },
  },
  batchesPage: {
    title: 'Batches',
    primaryAction: {
      label: 'Toevoegen',
    },
  },
  batchesOverview: {
    primaryAction: {
      label: 'Nieuwe batch',
    },
  },
  batch: {
    reference: 'Referentie',
    action: 'Actie',
    dataset: 'Dataset',
    isImport: 'Geimporteerd',
    isAccepted: 'Geaccepteerd',
    isConfirmed: 'Bevestigd',
    isReady: 'Afgerond',
    isFailing: 'Gefaald',
  },
  batchErrors: {
    title: 'Foutmeldingen',
    feedback: {
      failedJobNotice:
        'Batch is gefaald. Neem contact op met Afosto om uit te zoeken wat er mis ging.',
    },
  },
  batchConfig: {
    title: 'Configuratie',
  },
  viewBatch: {
    breadcrumbs: {
      batches: 'Batches',
    },
    subNavigation: {
      details: 'Details',
      communication: 'Communicatie',
    },
    secondaryActions: {
      validate: 'Valideren',
      confirm: 'Bevestigen',
    },
    validateProgressDialog: {
      message: 'Batch valideren',
    },
    feedback: {
      batchConfirmed: 'Batch is bevestigd',
      batchNotConfirmed: 'Batch kon niet worden bevestigd',
      batchValidationSucceeded: 'Batch validatie geslaagd',
      batchValidationFailed: 'Batch validatie niet geslaagd, controleer de foutmeldingen',
    },
  },
  createBatch: {
    title: 'Nieuwe batch',
  },
  pages: {
    root: {
      feedback: {
        fetchLocationsFailed:
          'Locaties konden niet worden opgehaald. Controleer je internetverbinding.',
      },
    },
    pick: {
      feedback: {
        itemNotProcessed: 'Item kon niet worden verwerkt',
        missingItemsRequestFailed: 'Controleren ontbrekende items mislukt',
      },
      lessPickedDialog: {
        title: 'Minder gepakt dan gevraagd',
        description:
          'Je hebt minder producten gepakt dan gevraagd. Weet je zeker dat je door wilt gaan? Zo niet, vergelijk dan het aantal gepakte producten met het verwacht aantal producten.',
      },
      lessThanChangeQuantityDialog: {
        title: 'Items uit pakket halen',
        description:
          'Let op: Het aantal dat je hebt gewijzigd ligt lager dan wat je van dit item in het huidige pakket hebt liggen. Selecteer een andere pakket om dit item ook uit andere pakketten te halen',
      },
      maxQuantityDialog: {
        title: 'Items gepakt',
        message: 'Je hebt het gevraagde aantal items al gepakt.',
      },
      noParcelQuantityDialog: {
        title: 'Item uit pakket halen',
        description:
          'Je hebt alles van dit item al uit het huidige pakket gehaald. Selecteer een andere pakket om meer van dit item uit de overige pakketten te halen',
      },
      pickAllDialog: {
        title: 'Alle items pakken',
        packTitle: 'Alle items pakken en inpakken',
        message: 'Weet je zeker dat je alle items in 1 keer wilt pakken',
        packMessage:
          'Weet je zeker dat je alle items in 1 keer wilt pakken en inpakken? Alle resterende items worden toegevoegd aan het huidige pakket',
        feedback: {
          pickAllFailed: 'Pakken van alle items mislukt',
          pickAndPackAllFailed: 'Pakken en inpakken van alle items mislukt',
        },
      },
      pickMissingItemsDialog: {
        title: 'Ontbrekende items',
        feedback: {
          missingItemsNotReported: 'Ontbrekende items konden niet worden gerapporteerd',
        },
      },
      requestedQuantityPickedDialog: {
        title: 'Gevraagde hoeveelheid gepakt',
        description:
          'Je hebt de gevraagde hoeveelheid al gepakt. Controleer of je niet te veel hebt gepakt.',
      },
      itemQuantityDialog: {
        title: 'Pakken',
      },
      pickFollowUpActionsDialog: {
        title: 'Alle items gepakt',
        message:
          'Je hebt alle items gepakt. Wil je doorgaan met het inpakken van de gepakte items of met het pakken van een andere verzending?',
      },
      pickFinishedDialog: {
        title: 'Picken afgerond',
        message:
          'Je hebt het picken afgerond. Je kunt nu doorgaan met het picken van andere verzendingen.',
      },
    },
    putaway: {
      bulkActions: {
        putaway: 'Wegleggen',
      },
      progressDialog: {
        isPuttingAway: 'Items wegleggen',
      },
      confirmOverageDialog: {
        title: 'Meer items weggelegd',
        description:
          'Je hebt meer items weggelegd dan verwacht. Weet je zeker dat je meer items hebt ontvangen? Zo niet, klik op annuleren en controleer het aantal weggelegde items.',
      },
      itemQuantityDialog: {
        title: 'Product wegleggen',
        quantityCounter: {
          received: 'Ontvangen',
          putaway: 'Weggelegd',
        },
      },
      positionDialog: {
        title: 'Positie opgeven',
      },
      remainingItemsDialog: {
        title: 'Resterende producten',
        description:
          'Er staan nog producten op de werklijst die nog niet zijn weggelegd. Controleer of je deze producten hebt of klik op afronden.',
      },
      unknownItemDialog: {
        title: 'Product niet gevonden',
        description:
          'Het product wat je hebt gescand staat niet op deze werklijst. Wil je het product aanmelden als te veel ontvangen?',
      },
      feedback: {
        itemsNotPutaway: 'Producten konden niet worden weggelegd',
        multipleItemsPutaway: 'Producten zijn weggelegd',
        multipleItemsNotPutaway: 'Producten konden niet worden weggelegd',
        putawayNotFinished: 'Werklijst kon niet worden afgerond',
        unknownPosition:
          'De ingevulde positie is niet geregistreerd. Verander de positie naar een geregistreerde positie.',
      },
    },
    shipmentsSection: {
      title: 'Verzendingen',
    },
    handlingListView: {
      breadcrumb: {
        handlingLists: 'Werklijsten',
      },
      subNavigation: {
        details: 'Details',
        items: 'Items',
        logs: 'Activiteiten',
      },
      actions: {
        pick: 'Picken',
        place: 'Wegleggen',
      },
      feedback: {
        handlingListDeleted: 'Werklijst verwijderd',
        handlingListNotDeleted: 'Werklijst kan niet worden verwijderd',
      },
    },
    parkParcels: {
      title: 'Pakketten parkeren',
      search: {
        placeholder: 'Pakketnummer',
      },
      feedback: {
        parcelAlreadySent: 'Pakket is al verzonden',
        parcelNotFound: 'Pakket niet gevonden',
      },
    },
    parcels: {
      title: 'Pakketten',
      secondaryActions: {
        switchLocations: 'Locaties wijzigen',
      },
      emptyMessage: 'Geen pakketten gevonden',
      bulkActions: {
        markInTransit: 'Onderweg',
        markFinished: 'Afgerond',
      },
      feedback: {
        parcelsMarkedFinished: 'Pakketten kunnen worden afgerond',
        parcelsMarkedNotFinished: 'Pakketten kunnen niet worden afgerond',
        parcelsMarkedInTransit: 'Pakketten zijn gemarkeerd als onderweg',
        parcelNotFound: 'Pakket niet gevonden',
        parcelsNotMarkedInTransit: 'Pakketten kunnen niet worden gemarkeerd als onderweg',
      },
    },
    shippingMethods: {
      title: 'Verzendmethoden',
      emptyMessage: 'Geen verzendmethoden',
    },
    viewHandlingList: {
      breadcrumbs: {
        handlingLists: 'Werklijsten',
      },
      details: {
        infoSection: {
          title: 'Informatie',
        },
      },
    },
    processHandlingList: {
      breadcrumbs: {
        handlingLists: 'Werklijsten',
      },
      secondaryActions: {
        addItem: 'Product toevoegen',
        history: 'Historie',
        pickAll: 'Alles pakken',
        pickAndPackAll: 'Alles pakken en inpakken',
      },
      finishedAlert: {
        message: 'Deze werklijst is al afgerond',
        actions: {
          viewList: 'Bekijk werklijst',
        },
      },
    },
    moveInventory: {
      title: 'Voorraad verplaatsen',
      scanPositionDialog: {
        title: 'Scan een positie',
        description: 'Scan de positie waar je de producten weg gaat pakken',
      },
      emptyMessage: 'Nog geen posities gescand',
      primaryAction: {
        label: 'Positie scannen',
      },
      actions: {
        putAway: 'Wegleggen',
      },
      confirmPutAway: {
        title: 'Bevestig producten',
        description: 'Weet je zeker dat je klaar bent met het verzamelen van de producten?',
        buttons: {
          cancel: 'Annuleren',
          confirm: 'Bevestigen',
        },
      },
      productsDialog: {
        emptyMessage: 'Nog geen producten gescand',
        addProduct: {
          title: 'Product toevoegen',
        },
      },
      feedback: {
        inventoryNotMoved: 'Voorraad kon niet worden verplaatst',
      },
    },
    fulfilmentLocations: {
      title: 'Fulfilment locaties',
      create: {
        button: 'Locatie toevoegen',
      },
      emptyMessage: 'Geen fulfilment locaties',
      noAddressMessage: 'Geen adres',
      createFulfilmentLocationDrawer: {
        title: 'Fulfilment locatie toevoegen',
        feedback: {
          fulfilmentLocationCreated: 'Fulfilment locatie is aangemaakt',
          fulfilmentLocationNotCreated: 'Fulfilment locatie kon niet worden aangemaakt',
        },
      },
      editDrawer: {
        title: 'Fulfilment locatie wijzigen',
      },
      confirmDelete: {
        title: 'Fulfiment locatie verwijderen',
        description: 'Weet je zeker dat je deze fulfilment locatie wilt verwijderen?',
      },
      feedback: {
        fulfilmentLocationUpdated: 'Fulfilment locatie is bijgewerkt',
        fulfilmentLocationNotUpdated: 'Fulfilment locatie kon niet worden bijgewerkt',
        fulfilmentLocationDeleted: 'Fulfilment locatie verwijderd',
        fulfilmentLocationNotDeleted: 'Fulfilment locatie kon niet worden verwijderd',
      },
    },
    handlingLists: {
      title: 'Werklijsten',
      secondaryActions: {
        switchLocations: 'Locaties wijzigen',
      },
      items: {
        feedback: {
          printingPackingSlips: {
            message: 'Pakbonnen afdrukken...',
          },
          printedPackingSlips: {
            title: 'Pakbonnen geprint',
            message:
              'De pakbonnen liggen klaar bij de printer. Je kunt deze gelijk verzenden of andere pakbonnen pakken.',
            actions: {
              ship: 'Verzenden',
              keepPicking: 'Pakbonnen',
            },
          },
          lessThanRequestedAmountPickedDialog: {
            title: 'Minder dan gevraagd',
            description:
              'Je hebt minder items gepakt dan gevraagd. Als het product niet op voorraad is ga dan verder. Is dat niet het geval, vergelijk dan het aantal gepakte items met het gevraagde aantal.',
          },
        },
      },
      confirmViewHandlingList: {
        title: 'Werklijst al afgerond',
        description: 'Deze werklijst is al afgerond. Je kan hem bekijken of een andere selecteren.',
      },
    },
    pickLists: {
      title: 'Werklijsten',
      items: {
        feedback: {
          printingPackingSlips: {
            message: 'Pakbonnen afdrukken...',
          },
          printingFailedDialog: {
            title: 'Pakbonnen afdrukken mislukt',
            message: 'Het printen van de pakbonnen is mislukt.',
            actions: {
              retry: 'Opnieuw printen',
            },
          },
          printedPackingSlips: {
            title: 'Werklijst afgerond',
            message:
              'Deze werklijst is nu afgerond. Je kunt nu de producten op deze werklijst gaan inpakken of verder gaan met het pakken van een andere werklijst.',
            actions: {
              ship: 'Inpakken',
              keepPicking: 'Werklijsten',
            },
          },
          lessThanRequestedAmountPickedDialog: {
            title: 'Minder dan gevraagd',
            description:
              'Je hebt minder items gepakt dan gevraagd. Als het product niet op voorraad is ga dan verder. Is dat niet het geval, vergelijk dan de gepakte product aantallen met de gevraagde aantallen.',
          },
        },
      },
    },
    pickView: {
      feedback: {
        requestedAmountPickedDialog: {
          title: 'Gevraagde hoeveelheid gepakt',
          description:
            'Je hebt de gevraagde hoeveelheid al gepakt. Controleer of je niet te veel hebt gepakt.',
        },
        noBoxedQuantityDialog: {
          title: 'Product uit pakket halen',
          description:
            'Je hebt alles van dit product al uit het huidige pakket gehaald. Selecteer een andere pakket om meer van dit product uit de pakketten te halen',
          buttons: {
            close: 'Sluiten',
            changeParcels: 'Pakket selecteren',
          },
        },
        lessThanChangeQuantityDialog: {
          title: 'Product uit pakket halen',
          description:
            'Let op: Het product aantal dat je hebt gewijzigd ligt lager dan wat je van dit product in het huidige pakket hebt liggen. Selecteer eventueel een andere pakket om dit product ook uit andere pakketten te halen',
          buttons: {
            close: 'Sluiten',
            changeParcels: 'Pakket selecteren',
          },
        },
        wrongBarcode: {
          title: 'Verkeerde barcode',
          description:
            'De barcode die je hebt gescand is niet van het gevraagde product. Controleer of je wel het juiste product hebt gepakt.',
        },
      },
      selectParcelDialog: {
        title: 'Selecteer een pakket',
        numberOfItems: 'Aantal: {count}',
        buttons: {
          createParcel: 'Nieuw pakket',
        },
      },
    },
    shipments: {
      title: 'Verzendingen',
      secondaryActions: {
        switchLocations: 'Locaties wijzigen',
      },
      create: {
        button: 'Toevoegen',
      },
      emptyMessage: 'Geen verzendingen',
      subNavigation: {
        outbound: 'Uitgaande',
        inbound: 'Inkomende',
      },
      feedback: {
        noCancelledShipments:
          'Werklijst kan niet worden aangemaakt. Sommige geselecteerde verzendingen zijn geannuleerd.',
        picklistNotCreated:
          'Werklijst kan niet worden aangemaakt. Je kunt alleen een werklijst maken van verzendingen die nog niet op een werklijst staan.',
        shipmentsNotAllEqualIsOutbound:
          'Werklijst kan niet worden aangemaakt. Niet alle geselecteerde verzendingen zijn {prop}.',
        shipmentsNotAllEqualLocation:
          'Werklijst kan niet worden aangemaakt. Niet alle verzendingen gaan naar of komen van locatie {location}.',
        shipmentCanNotBePicked: 'Het pakken van deze verzending kon niet worden gestart',
        shipmentCanNotBePlaced: 'Het wegleggen van deze verzending kon niet worden gestart',
        shipmentNotFound: 'Verzending kan niet worden gevonden',
      },
      actions: {
        pick: 'Werklijst maken',
      },
    },
    editShipment: {
      title: 'Verzending bewerken',
      feedback: {
        shipmentNotUpdated: 'Verzending kon niet worden bijgewerkt',
      },
      cancelDialog: {
        title: 'Bewerken van verzending annuleren',
        description:
          'Weet je zeker dat je wilt stoppen met het bewerken van deze verzending? Alle wijzigingen worden ongedaan gemaakt.',
        actions: {
          cancel: 'Annuleren',
          ok: 'Ok',
        },
      },
    },
    addressSection: {
      title: 'Adressen',
      fromAddress: {
        title: 'Van',
        emptyMessage: 'Geen adres',
      },
      toAddress: {
        title: 'Naar',
        emptyMessage: 'Geen adres',
      },
    },
    overview: {
      title: 'Overzicht',
    },
    settings: {
      title: 'Instellingen',
      subNavigation: {
        general: 'Algemeen',
        fulfilmentLocations: 'Fulfilment locaties',
        shippingMethods: 'Verzendmethoden',
      },
      createFulfilmentLocation: {
        button: 'Locatie toevoegen',
      },
      feedback: {
        settingsUpdated: 'Instellingen zijn bijgewerkt',
        settingsNotUpdated: 'Instellingen konden niet worden bijgewerkt',
      },
      sections: {
        location: {
          title: 'Locatie',
          subtitle: 'Deze instellingen gelden alleen voor dit apparaat',
          editDrawer: {
            title: 'Locaties wijzigen',
          },
          feedback: {
            noLocationSelected: 'Geen locatie geselecteerd',
            locationSettingsSaved: 'Locatie gewijzigd',
          },
        },
        shipments: {
          title: 'Verzendingen',
          settings: {
            alwaysUnpackInboundShipments:
              'Inkomende verzendingen eerst uitpakken vervolgens wegleggen',
            showCreateShipmentButtonMobile: 'Toon verzending aanmaken knop op mobiele apparaten',
            dontPrintPackingSlipForDestinationLocations:
              'Print geen pakbonnen voor de volgende eindbestemmingen',
          },
          locationsDrawer: {
            title: 'Selecteer eindbestemmingen',
          },
          feedback: {
            noLocationsSelected: 'Geen eindbestemmingen geselecteerd',
          },
        },
        general: {
          title: 'Algemeen',
          editItemsAllButtonSettings: {
            title: 'Wijzig alles knop zichtbaarheid instellingen',
          },
          settings: {
            showItemsAllButton: 'Zichtbaarheidsinstellingen alles knop',
            minRequestedQuantity: 'Minimaal aantal items',
            atLeastOneProductManually: 'Het eerste product handmatig afhandelen',
            showPositionSuggestions: 'Toon product positie suggesties',
          },
        },
        spooler: {
          title: 'Spooler',
          subtitle: 'Deze instellingen gelden alleen voor dit apparaat',
          labelPrinter: {
            title: 'Label printer',
          },
          labelEditDrawer: {
            title: 'Label printer wijzigen',
          },
          a4Printer: {
            title: 'A4 printer',
          },
          a4EditDrawer: {
            title: 'A4 printer wijzigen',
          },
          barcodePrinter: {
            title: 'Barcode printer',
          },
          barcodeEditDrawer: {
            title: 'Barcode printer wijzigen',
            fields: {
              printer: {
                label: 'Barcode printer',
              },
            },
          },
          feedback: {
            noPrinterSelected: 'Geen printer geselecteerd',
            printerSettingsSaved: 'Spooler instellingen opgeslagen',
          },
        },
      },
    },
    createShipment: {
      title: 'Verzending toevoegen',
    },
    shipmentView: {
      breadcrumb: {
        shipments: 'Verzendingen',
      },
      subNavigation: {
        details: 'Details',
        items: 'Items',
        overage: 'Te veel ontvangen',
        parcels: 'Pakketten',
        logs: 'Activiteiten',
      },
      secondaryActions: {
        cancelShipment: 'Verzending annuleren',
        finishShipment: 'Verzending afronden',
        updatePositions: 'Item posities bijwerken',
        triggerDataFlow: 'Trigger dataflow',
      },
      actions: {
        start: 'Start',
        edit: 'Bewerken',
        pick: 'Picken',
        pickAndBox: 'Picken & inpakken',
        pack: 'Inpakken',
        unpack: 'Uitpakken',
        place: 'Wegleggen',
      },
      finishShipmentDialog: {
        message: 'Verzending afronden',
      },
      updatePositionsDialog: {
        title: 'Item posities bijwerken',
        description:
          'Weet je zeker dat je de item posities wilt bijwerken naar de laatste voorkeursposities? De huidige item posities op deze verzending zullen worden overschreven.',
      },
      feedback: {
        positionsUpdated: 'Item posities zijn bijgewerkt',
        positionsNotUpdated: 'Item posities konden niet worden bijgewerkt',
        shipmentCancelled: 'Verzending is geannuleerd',
        shipmentNotCancelled: 'Verzending kon niet worden geannuleerd',
        shipmentFinished: 'Verzending is afgerond',
        shipmentNotFinished: 'Verzending kon niet worden afgerond',
      },
      shipmentInfoSection: {
        title: 'Informatie',
      },
      shipmentContactSection: {
        title: 'Contact',
      },
      shipmentHandlingListSection: {
        title: 'Werklijst',
      },
      shippingMethodSection: {
        title: 'Verzendmethode',
        overview: {
          name: 'Naam',
          description: 'Omschrijving',
          deliveryDuring: 'Levering tijdens',
          isSameDay: 'Dezelfde dag geleverd',
          isSunday: 'Geleverd op zondag',
          isCarrierLocation: 'Koerierlocatie',
          isNeighbourAllowed: 'Afleveren bij buren mogelijk',
        },
        emptyMessage: 'Geen verzendmethode',
      },
      shipmentStatusSection: {
        title: 'Status',
        overview: {
          isOutbound: 'Uitgaand',
          isListed: 'Werklijst',
          isFinished: 'Afgerond',
          isInTransit: 'Onderweg',
          isDelivered: 'Geleverd',
          isLabeled: 'Verzendlabel',
          isBoxed: 'Ingepakt',
          isComplete: 'Compleet',
          isOvercomplete: 'Overcompleet',
          isCancelled: 'Geannuleerd',
          handlingListStatus: 'Werklijst status',
        },
      },
      parcels: {
        emptyMessage: 'Geen pakketten',
      },
    },
    packing: {
      title: 'Inpakken',
      search: {
        placeholder: 'Verzendnummer',
      },
      backToShipments: 'Terug naar verzendingen',
      emptyMessage: {
        list: 'Je hebt alle verzendingen al ingepakt.',
        shipments: 'Geen beschikbare verzendingen',
      },
      feedback: {
        shipmentAlreadyBoxed: 'Verzending is al ingepakt',
      },
    },
    packingView: {
      breadcrumbs: {
        packing: 'Inpakken',
      },
      finishedPackingDialog: {
        title: 'Klaar met inpakken',
        message:
          'Je bent klaar met het inpakken van de pakketten. Je kunt doorgaan met inpakken of het pakken van andere verzendingen.',
        actions: {
          shipments: 'Verzendingen',
          pack: 'Inpakken',
        },
      },
      alreadyPackedMessage: {
        message: 'Deze verzending is al ingepakt',
      },
      pickFirstMessage: {
        message: 'De items op deze verzending moeten eerst nog worden gepakt',
      },
    },
    unpackingView: {
      breadcrumbs: {
        parcels: 'Pakketten',
        shipments: 'Verzendingen',
      },
      finishedUnpackingDialog: {
        title: 'Uitpakken afgerond',
        message:
          'Je bent klaar met het uitpakken van de pakketten. Wil je doorgaan met het uitpakken van andere verzendingen of wil je de huidige producten weg gaan leggen?',
        actions: {
          keepUnpacking: 'Doorgaan met uitpakken',
        },
      },
      alreadyUnpackedMessage: {
        message: 'Deze verzending is al uitgepakt',
      },
      alreadyPlacedMessage: {
        message: 'De items op deze verzending zijn al weggelegd',
      },
      feedback: {
        handlingListNotCreated: 'Werklijst kon niet worden aangemaakt',
      },
    },
    viewPicklist: {
      printShippingLabelsDialog: {
        description: 'Printen van pakbonnen...',
      },
      confirmPrintShippingLabelsDialog: {
        title: 'Pakbonnen',
        description:
          'Wil je doorgaan met het downloaden / printen van de pakbonnen voor deze werklijst?',
        buttons: {
          skip: 'Overslaan',
          continue: 'Doorgaan',
        },
      },
      confirmFinishHandlingListDialog: {
        title: 'Afronden werklijst',
        description:
          'Weet je zeker dat je deze werklijst wilt afronden? Je kunt de werklijst achteraf niet meer wijzigen',
        buttons: {
          cancel: 'Annuleren',
          confirm: 'Bevestigen',
        },
      },
      missingProductsDialog: {
        title: 'Missende producten',
        description:
          'Het gepakte aantal is voor sommige items niet gelijk aan het gevraagde aantal. Controleer deze producten of ga verder.',
      },
    },
    viewFulfilmentLocation: {
      breadcrumb: {
        fulfilmentLocations: 'Fulfilment locaties',
        settings: 'Instellingen',
      },
      subNavigation: {
        positions: 'Posities',
        sorting: 'Sortering',
      },
      primaryAction: {
        add: {
          label: 'Toevoegen',
        },
        addMultiple: {
          label: 'Bulk toevoegen',
        },
      },
      deletedMessage: 'Deze fulfilment locatie is verwijderd.',
      fulfilmentLocationDetails: {
        title: 'Informatie',
      },
      fulfilmentLocationPositions: {
        title: 'Posities',
        button: {
          create: {
            label: 'Toevoegen',
          },
        },
        emptyMessage: 'Geen posities gevonden',
        positionDialog: {
          title: 'Producten',
        },
        addMultiplePositionsDrawer: {
          title: 'Meerdere posities toevoegen',
        },
        feedback: {
          positionsAdded: 'Posities toegevoegd',
          positionsNotAdded: 'Posities konden niet worden toegevoegd',
          positionsDeleted: 'Posities verwijderd',
          positionsNotDeleted: 'Posities konden niet worden verwijderd',
        },
        exportPositions: {
          title: 'Posities exporteren',
          reference: 'Posities export {group} {value}',
          batchCreateLabel: 'Posities voorbereiden',
          batchFailedLabel: 'Posities exporteren mislukt',
          batchStartLabel: 'Posities exporteren',
          batchValidationLabel: 'Posities en instellingen valideren',
        },
      },
      fulfilmentLocationSorting: {
        updatePositionsMessage: 'De sortering wordt automatisch opgeslagen',
        tooManyPositionsMessage:
          'Teveel posities om handmatig te sorteren, gebruik het "Bulk toevoegen" om je huidige posities te sorteren.',
        feedback: {
          positionsUpdated: 'Posities zijn bijgewerkt',
          positionsNotUpdated: 'Posities konden niet worden bijgewerkt',
        },
      },
      unknownLocation: {
        message: 'Deze locatie bestaat niet',
        title: 'Onbekende locatie',
      },
    },
    parcelView: {
      breadcrumb: {
        shipments: 'Verzendingen',
        parcels: 'Pakketten',
      },
      subNavigation: {
        details: 'Details',
        items: 'Items',
        logs: 'Activiteiten',
      },
      secondaryActions: {
        editParcelItems: 'Inhoud wijzigen',
        deleteParcel: 'Verwijderen',
        printLabel: 'Verzendlabel printen',
        printSlip: 'Pakbon printen',
        printTicket: 'Pakketbon printen',
        markFinished: 'Pakket afronden',
        markInTransit: 'Markeren als onderweg',
      },
      feedback: {
        noShippingMethod: 'De verzending heeft geen verzendmethode',
        parcelUpdated: 'Pakketinformatie is bijgewerkt',
        parcelNotUpdated: 'Pakketinformatie kon niet worden bijgewerkt',
        parcelDeleted: 'Pakket is verwijderd',
        parcelNotDeleted: 'Pakket kon niet worden verwijderd',
        parcelItemsRemoved: 'Geselecteerde items zijn verwijderd uit pakket',
        parcelItemsNotRemoved: 'Items konden niet worden verwijderd uit het pakket',
        parcelMarkedInTransit: 'Pakket gemarkeerd als onderweg',
        parcelNotMarkedInTransit: 'Pakket kan niet worden gemarkeerd als onderweg',
        parcelMarkedFinished: 'Pakket afgerond',
        parcelNotMarkedFinished: 'Pakket kan niet worden afgerond',
      },
      confirmRemoveItemsParcel: {
        title: 'Items verwijderen uit pakket',
        description:
          'Weet je zeker dat je de geselecteerde items wilt verwijderen uit het pakket? Deze actie kan niet ongedaan worden gemaakt.',
        buttons: {
          cancel: 'Annuleren',
          delete: 'Verwijderen',
        },
      },
      confirmDeleteParcel: {
        title: 'Pakket verwijderen',
        description:
          'Weet je zeker dat je het pakket wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
        buttons: {
          cancel: 'Annuleren',
          delete: 'Verwijderen',
        },
      },
      parcelInformationSection: {
        title: 'Informatie',
        button: {
          edit: {
            label: 'Wijzigen',
          },
        },
        editParcel: {
          title: 'Pakketinformatie bewerken',
        },
        overview: {
          shipment: 'Verzending',
          isOutbound: 'Uitgaand',
          trackingCode: 'Track & Trace code',
          trackingUrl: 'Track & Trace URL',
          isDelivered: 'Geleverd',
          size: 'Afmeting',
          weight: 'Gewicht',
          createdAt: 'Aangemaakt op',
          finishedAt: 'Afgerond op',
          inTransitAt: 'Onderweg op',
          shipAt: 'Verzenden op',
          position: 'Positie',
        },
      },
      progressDialog: {
        label: {
          fetching: 'Ophalen verzendlabel',
          printing: 'Printen verzendlabel',
        },
        slip: {
          fetching: 'Ophalen pakbon',
          printing: 'Printen pakbon',
        },
        ticket: {
          fetching: 'Ophalen pakketbon',
          printing: 'Printen pakketbon',
        },
      },
      printingFailedDialog: {
        label: {
          title: 'Verzendlabel printen mislukt',
          message: 'Het verzendlabel kon niet worden geprint',
        },
        slip: {
          title: 'Pakbon printen mislukt',
          message: 'De pakbon kon niet worden geprint',
        },
        ticket: {
          title: 'Pakketbon printen mislukt',
          message: 'De pakketbon kon niet worden geprint',
        },
      },
    },
    placeListItems: {
      item: {
        confirmPosition: 'Bevestig positie',
      },
      emptyMessage: 'Geen items',
      feedback: {
        confirmPositionDialog: {
          title: 'Positie bevestigen',
          description:
            'Scan de positie waar je het product neer wilt leggen of kies een van de suggesties',
        },
        requestedAmountSelectedDialog: {
          title: 'Verwachte aantal gescand',
          description:
            'Je hebt het verwachte aantal van dit product al behaald. Controleer of de aantallen kloppen.',
        },
        wrongBarcode: {
          title: 'Verkeerde barcode',
          description:
            'De barcode die je hebt gescand is niet juist. Controleer of je het juiste product hebt.',
        },
        itemsLeft: {
          title: 'Niet-geplaatste producten',
          description:
            'Er staan nog producten op de lijst die nog niet geplaatst zijn. Controleer of je deze producten hebt of klik op afronden.',
        },
        itemsNotPlacedOnPosition: 'Items niet geplaatst op positie',
        differentProduct: {
          title: 'Ander product',
          description:
            'De barcode die je hebt gescand is van een ander product. Controleer of je het juiste product hebt.',
        },
      },
    },
  },
  packingList: {
    items: {
      emptyMessage: 'Geen items beschikbaar',
      addAllButton: {
        label: 'Alles toevoegen',
      },
    },
    secondaryActions: {
      addAll: 'Alles toevoegen',
    },
    actions: {
      newParcel: 'Nieuw pakket',
      finishParcel: 'Afronden',
    },
    confirmParcelChanges: {
      title: 'Bevestig pakket wijzigingen',
      description:
        'Weet je zeker dat je een ander pakket wilt openen? De huidige wijzigingen in dit pakket zullen worden doorgevoerd.',
      buttons: {
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
      },
    },
    feedback: {
      parcelNotCreated: 'Pakket kan niet worden aangemaakt',
      parcelFinished: 'Producten zijn toegevoegd aan het pakket',
      parcelNotFinished: 'Producten konden niet worden toegevoegd aan het pakket',
    },
    confirmFinishParcels: {
      title: 'Pakketten afronden',
      description:
        'Weet je zeker dat je klaar bent met het toewijzen van de producten aan de pakketten?',
      buttons: {
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
      },
    },
    confirmNewParcel: {
      title: 'Nieuw pakket toevoegen',
      description:
        'Weet je zeker dat je een nieuw pakket wilt toevoegen? Je kunt de producten in het huidige pakket hierna niet meer aanpassen.',
      buttons: {
        cancel: 'Annuleren',
        newParcel: 'Nieuw pakket',
      },
    },
  },
  printingFailedDialog: {
    actions: {
      close: 'Sluiten',
      download: 'Downloaden',
      retry: 'Opnieuw',
    },
  },
  printerDialog: {
    title: 'Selecteer een printer',
    actions: {
      cancel: 'Annuleren',
    },
  },
  hubDialog: {
    title: 'Selecteer een hub',
  },
  fulfilmentLocationsDialog: {
    title: 'Selecteer je locaties',
    titleSingle: 'Selecteer je locatie',
  },
  parcel: {
    noParcelMessage: 'Geen pakket',
    createNewParcelMessage: 'Maak een nieuw pakket aan',
    numberOfItems: 'Aantal items: {number}',
    actions: {
      edit: 'Wijzigen',
      new: 'Nieuw',
    },
    feedback: {
      parcelNotCreated: 'Pakket kon niet worden aangemaakt',
      parcelNotSelected: 'Pakket kon niet worden geselecteerd',
    },
  },
  dateOptions: {
    today: 'Vandaag',
    relativeNow: 'Relatief vanaf nu',
    relative: 'Relatief',
    date: 'Datum',
  },
  relativeDate: {
    properties: {
      quantity: 'Aantal',
      dayOfWeek: 'Dag van de week',
      dayOfMonth: 'Dag van de maand',
      type: 'Type',
      time: 'Tijd',
    },
    dateTypeOptions: {
      minutes: 'Minuten',
      hours: 'Uren',
      days: 'Dagen',
      weeks: 'Weken',
      months: 'Maanden',
    },
  },
  dataList: {
    emptyMessage: 'Geen items',
    pagination: {
      currentPageLabel: 'Pagina {page}',
      previousPageLabel: 'Vorige pagina',
      nextPageLabel: 'Volgende pagina',
      displayedRows: '{from} - {to} van {count}',
      many: 'veel',
    },
    selection: {
      all: 'Alles',
      actions: {
        deselectAll: 'Alles deselecteren',
        selectAll: 'Alles selecteren',
        selectPage: 'Pagina selecteren',
      },
    },
  },
  viewSelection: {
    title: 'Opgeslagen views',
    actions: {
      setAsDefault: 'Instellen als standaard',
    },
    confirmDeleteView: {
      title: 'View verwijderen',
      description: 'Weet je zeker dat je deze view wilt verwijderen?',
      buttons: {
        cancel: 'Annuleren',
        delete: 'Verwijderen',
      },
    },
  },
  filterSelection: {
    title: 'Filters',
    resetButton: 'Reset filters',
    rowCount: '{count} van {total}',
    filterSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newFilterHeader: 'Filter toevoegen',
    },
  },
  dataGrid: {
    defaultView: {
      name: 'Standaard',
      description: 'Standaard weergave',
    },
    columns: {
      auditLogs: {
        actor: 'Gebruiker',
        action: 'Actie / Code',
        url: 'Url',
        resource: 'Bron',
        stream: 'Stream',
        trace: 'Trace',
        category: 'Categorie',
        processedAt: 'Verwerkt op',
        createdAt: 'Aangemaakt op',
      },
      orders: {
        amount: 'Bedrag',
        number: 'Ordernummer',
        createdAt: 'Aangemaakt op',
        total: 'Totaal',
        type: 'Type',
      },
      batchErrors: {
        reference: 'Regel',
        column: 'Kolom',
        message: 'Melding',
      },
      batches: {
        reference: 'Referentie',
        action: 'Actie',
        isImport: 'Import',
        type: 'Type',
        isAccepted: 'Geaccepteerd',
        isConfirmed: 'Bevestigd',
        isReady: 'Klaar',
        isFailing: 'Gefaald',
        createdAt: 'Aangemaakt op',
      },
      shippingMethods: {
        name: 'Naam',
        description: 'Omschrijving',
        maxWeight: 'Max. gewicht',
        deliveryDuring: 'Levering tijdens',
        isSameDay: 'Dezelfde dag geleverd',
        isSunday: 'Zondag geleverd',
        carrierCode: 'Verzender',
        provider: 'Provider',
        isConfigured: 'Ingesteld',
      },
      shipments: {
        number: 'Verzendnummer',
        isEditable: 'Bewerkbaar',
        isOutbound: 'Uitgaand',
        isListed: 'Op werklijst',
        isFinished: 'Afgerond',
        isInTransit: 'Onderweg',
        isDelivered: 'Geleverd',
        isReady: 'Klaar om te pakken',
        is_ready: 'Klaar om te pakken',
        waitingOn: 'Wacht op verzending',
        waiting_on: 'Wacht op verzending',
        expectedAt: 'Verwacht op',
        createdAt: 'Aangemaakt op',
        method_id: 'Verzendmethode',
        contact_id: 'Contact',
        postal_code: 'Postcode',
        locality: 'Plaats',
        location: 'Locatie',
        country_code: 'Land',
        expected_at: 'Verwacht op',
        is_outbound: 'Uitgaand',
        is_labeled: 'Verzendlabel',
        is_serviced: 'Extra service',
        is_complete: 'Compleet',
        is_overcomplete: 'Overcompleet',
        is_canceled: 'Geannuleerd',
        is_boxed: 'Ingepakt / Geteld',
        is_handled: 'Gepakt / Weggelegd',
        is_listed: 'Op werklijst',
        is_finished: 'Afgerond',
        is_in_transit: 'Onderweg',
        list_id: 'Werklijst',
        skus: 'SKU',
        created_at: 'Aangemaakt op',
        search: 'Zoeken',
        shipAt: 'Verzenden op',
        ship_at: 'Verzenden op',
        order_number: 'Ordernummer',
        order_id: 'Order',
        orderId: 'Order',
        purchase_order_numbers: 'Inkoopordernummers',
        purchaseOrderNumber: 'Inkoopordernummers',
      },
      shippingItems: {
        sku: 'SKU',
        description: 'Omschrijving',
        quantity: 'Aantal',
        positions: 'Posities',
        totalListed: 'Op werklijst',
        totalBoxed: 'Ingepakt',
        totalCounted: 'Geteld',
        totalPlaced: 'Weggelegd',
        totalPicked: 'Gepakt',
        totalMissing: 'Ontbrekend',
      },
      shippingOverage: {
        sku: 'SKU',
        description: 'Omschrijving',
        position: 'Positie',
        quantity: 'Aantal',
      },
      parcelItems: {
        sku: 'SKU',
        description: 'Omschrijving',
        quantity: 'Aantal',
      },
      fulfilmentLocation: {
        name: 'Naam',
        createdAt: 'Aangemaakt op',
      },
      parcels: {
        number: 'Pakketnummer',
        trackingCode: 'Track & trace code',
        tracking_code: 'Track & trace code',
        trackingUrl: 'Track & trace URL',
        isDelivered: 'Geleverd',
        shipment: 'Verzending',
        shipment_id: 'Verzending',
        isInTransit: 'Onderweg',
        is_in_transit: 'Onderweg',
        in_transit_at: 'Onderweg op',
        inTransitAt: 'Onderweg op',
        isLabeled: 'Pakketlabel',
        is_labeled: 'Pakketlabel',
        isFinished: 'Afgerond',
        is_finished: 'Afgerond',
        is_outbound: 'Uitgaand',
        isOutbound: 'Uitgaand',
        finished_at: 'Afgerond op',
        finishedAt: 'Afgerond op',
        shipment_number: 'Verzendnummer',
        skus: "Sku's",
        size: 'Afmetingen',
        weight: 'Gewicht',
        createdAt: 'Aangemaakt op',
        created_at: 'Aangemaakt op',
        search: 'Zoeken',
        location: 'Locatie',
        position: 'Positie',
        shipAt: 'Verzenden op',
        ship_at: 'Verzenden op',
      },
      picklistItems: {
        sku: 'SKU',
        description: 'Omschrijving',
        quantity: 'Aantal',
      },
      handling: {
        number: 'Werklijstnummer',
        location: 'Locatie',
        shipments: 'Verzendingen',
        status: 'Status',
        isOutbound: 'Uitgaand',
        is_outbound: 'Uitgaand',
        startedAt: 'Gestart op',
        finishedAt: 'Afgerond op',
        finished_at: 'Afgerond op',
        dueAt: 'Afhandelen op',
        due_at: 'Afhandelen op',
        createdAt: 'Aangemaakt op',
        created_at: 'Aangemaakt op',
        is_finished: 'Afgerond',
        is_in_progress: 'Bezig',
        is_on_hold: 'In de wacht',
        is_serviced: 'Extra service',
        list_id: 'Werklijst',
        shipment_numbers: 'Verzendnummers',
        shipment_ids: 'Verzendingen',
        skus: "Sku's",
        started_at: 'Gestart op',
        expires_at: 'Verloopt op',
        search: 'Zoeken',
      },
      lists: {
        number: 'Werklijstnummer',
        location: 'Locatie',
        shipments: 'Verzendingen',
        status: 'Status',
        isOutbound: 'Uitgaand',
        is_outbound: 'Uitgaand',
        startedAt: 'Gestart op',
        finishedAt: 'Afgerond op',
        finished_at: 'Afgerond op',
        dueAt: 'Afhandelen op',
        due_at: 'Afhandelen op',
        createdAt: 'Aangemaakt op',
        created_at: 'Aangemaakt op',
        is_finished: 'Afgerond',
        is_in_progress: 'Bezig',
        is_on_hold: 'In de wacht',
        is_serviced: 'Extra service',
        list_id: 'Werklijst',
        shipment_numbers: 'Verzendnummers',
        shipment_ids: 'Verzendingen',
        skus: "Sku's",
        started_at: 'Gestart op',
        expires_at: 'Verloopt op',
        search: 'Zoeken',
      },
      fulfilmentLocations: {
        code: 'Positie',
        sorting: 'Sortering',
        createdAt: 'Aangemaakt op',
        skus: "SKU's",
      },
      handlingListItems: {
        sku: 'SKU',
        description: 'Omschrijving',
        position: 'Positie',
        quantity: 'Aantal',
        picked: 'Gepakt',
        placed: 'Weggelegd',
        handled: 'Gepakt',
        crate: 'Krat',
        shipment: 'Verzending',
      },
    },
    sortSelection: {
      title: 'Sortering',
      resetButton: 'Reset sortering',
    },
    sortDirections: {
      asc: 'Oplopend',
      desc: 'Aflopend',
    },
    sortOptionSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newSortOptionHeader: 'Sortering toevoegen',
    },
    filters: {
      label: {
        between: '{name} tussen {first} en {second}',
      },
    },
    filterOperators: {
      is: 'Is gelijk aan',
      in: 'Bevat',
      missing: 'Bevat geen waarde',
      not_in: 'Bevat niet',
      gt: 'Is groter dan',
      gte: 'Is groter dan of gelijk aan',
      lt: 'Is kleiner dan',
      lte: 'Is kleiner dan of gelijk aan',
      between: 'Is tussen',
    },
    filterValues: {
      noValue: 'geen waarde',
    },
    filterConjunctions: {
      and: 'en',
    },
    formatters: {
      batches: {
        status: {
          accepted: 'Geaccepteerd',
          confirmed: 'Bevestigd',
          done: 'Klaar',
          failed: 'Gefaald',
        },
        type: {
          import: 'Import',
          export: 'Export',
        },
      },
    },
    columnSelection: {
      title: 'Kolommen',
      searchField: {
        placeholder: 'Zoeken ...',
      },
      addColumn: {
        label: 'Kolom toevoegen',
      },
      availableColumns: {
        label: 'Beschikbare kolommen',
      },
      selectedColumns: {
        label: 'Geselecteerde kolommen',
      },
      resetButton: 'Reset kolommen',
    },
    addColumn: {
      title: 'Kolom toevoegen',
      inputs: {
        name: {
          label: 'Naam',
        },
        formula: {
          label: 'Formule',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
    gridActions: {
      view: {
        title: 'Views',
        settings: 'Instellingen',
        views: 'Views',
        showMore: 'Toon meer',
        saveAs: 'Opslaan als',
        manageSettings: 'Beheren',
        defaultSettings: 'Terugzetten naar standaard',
      },
      columnSelection: {
        title: 'Kolommen',
      },
      sorting: {
        title: 'Sortering',
      },
      dataExport: {
        title: 'Exporteren',
        currentColumns: 'Huidige kolommen',
        allColumns: 'Alle kolommen',
        csv: 'CSV',
        excel: 'Excel',
        pdf: 'PDF',
      },
      dataImport: {
        title: 'Importeren',
      },
      copyGridUrl: {
        title: 'URL kopiëren',
        tooltip: 'Url gekopieerd',
      },
    },
    search: {
      placeholder: 'Zoek',
      exactMatch: 'Exacte match: {state}',
    },
    selection: {
      button: {
        all: 'Alles',
      },
      selected: '{count} van {total} geselecteerd',
    },
    pagination: {
      currentPageLabel: 'pagina {page}',
      previousPageLabel: 'Vorige pagina',
      nextPageLabel: 'Volgende pagina',
      displayedRows: '{from} - {to} van {count}',
      rowsPerPage: 'Rijen per pagina:',
      many: 'veel',
    },
    exportSelection: {
      title: 'Exporteren',
    },
    views: {
      label: {
        system: 'Systeem',
        private: 'Privé',
      },
    },
    viewSelectionMenu: {
      activeView: {
        label: 'Weergave',
      },
    },
    saveView: {
      title: 'Weergave opslaan als',
      showViewInformation: {
        button: {
          show: 'Toon informatie',
          hide: 'Verberg informatie',
        },
        columns: 'Kolommen',
        filters: 'Filters',
        sorting: 'Sortering',
        itemsPerPage: 'Rijen per pagina',
      },
      inputs: {
        name: {
          label: 'Naam',
          helperText: 'Gebruik een bestaande naam om de weergave te overschrijven',
        },
        saveViewForTenant: {
          label: 'Beschikbaar voor elke gebruiker',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
  },
  actions: {
    add: 'Toevoegen',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    filter: 'Filter',
    goToList: 'Bekijk overzicht',
    save: 'Opslaan',
    continue: 'Verder',
    check: 'Controleren',
    close: 'Sluiten',
    showTrackingInfo: 'Toon tracking informatie',
    finish: 'Afronden',
    discard: 'Ongedaan maken',
    edit: 'Wijzigen',
    next: 'Volgende',
    back: 'Vorige',
    previous: 'Vorige',
    run: 'Uitvoeren',
    runLater: 'Later uitvoeren',
    addProduct: 'Product toevoegen',
    view: 'Bekijken',
    upload: 'Uploaden',
    place: 'Wegleggen',
    pick: 'Picken',
    pack: 'Inpakken',
    manually: 'Handmatig',
    automatically: 'Automatisch',
    putAway: 'Wegleggen',
    shipments: 'Verzendingen',
    changeParcels: 'Pakket selecteren',
    newParcel: 'Nieuw pakket',
    viewParcels: 'Pakketten bekijken',
    packing: 'Inpakken',
    unpacking: 'Uitpakken',
    park: 'Parkeren',
    ship: 'Verzenden',
    pickAll: 'Alles pakken',
    pickAndPackAll: 'Alles pakken en inpakken',
    update: 'Bijwerken',
  },
  pagination: {
    pageNumber: 'Pagina {i}',
  },
  formActions: {
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  addressOptions: {
    address: 'Adres',
    location: 'Locatie',
  },
  shipmentForm: {
    from: {
      title: 'Van',
    },
    to: {
      title: 'Naar',
    },
  },
  contactFormSection: {
    title: 'Contact',
    search: {
      placeholder: 'Contact zoeken',
    },
    button: {
      create: {
        label: 'Nieuw contact',
      },
    },
  },
  organisationFormSection: {
    title: 'Organisatie',
    button: {
      create: {
        label: 'Nieuwe organisatie',
      },
    },
  },
  createContact: {
    title: 'Nieuw contact',
    feedback: {
      contactCreated: 'Contact is aangemaakt',
      contactNotCreated: 'Contact kon niet worden aangemaakt',
    },
  },
  shipmentFormSection: {
    otherTypeOptions: {
      inbound: 'Uitgaande verzending aanmaken',
      outbound: 'Inkomende verzending aanmaken',
    },
  },
  addressFormSection: {
    title: 'Adres',
    button: {
      select: {
        label: 'Adres selecteren',
      },
    },
    emptyMessage: 'Geen adres geselecteerd',
  },
  selectAddress: {
    title: 'Adres selecteren',
    button: {
      create: 'Adres toevoegen',
    },
    groups: {
      contact: 'Contact',
      organisation: 'Organisatie',
      other: 'Overig',
    },
  },
  confirmCancelFormDialog: {
    title: 'Venster verlaten',
    description:
      'Weet je zeker dat je het venster wilt verlaten? Wijzigingen zullen niet worden opgeslagen.',
    buttons: {
      cancel: 'Annuleren',
      leaveWindow: 'Venster verlaten',
    },
  },
  productsDialog: {
    actions: {
      scanPosition: 'Producten pakken',
      putAway: 'Wegleggen',
    },
  },
  productNotFoundDialog: {
    title: 'Product niet gevonden',
    description:
      'Het product dat je hebt gescand kan niet worden gevonden. Controleer of je het juiste product hebt gepakt.',
    message:
      'Het product dat je hebt gescand kan niet worden gevonden. Controleer of je het juiste product hebt gepakt.',
  },
  createAddress: {
    title: 'Adres toevoegen',
    feedback: {
      addressCreated: 'Adres is toegevoegd',
      addressNotCreated: 'Adres kon niet worden toegevoegd',
    },
  },
  stackItemList: {
    title: 'Producten',
    button: {
      create: {
        label: 'Toevoegen',
      },
    },
    actions: {
      remove: {
        label: 'Verwijderen',
      },
    },
    createItem: {
      title: 'Product toevoegen',
    },
    emptyMessage: 'Nog geen producten toegevoegd',
  },
  pickListStatus: {
    inProgress: 'Bezig',
    onHold: 'In de wacht',
    cancelled: 'Geannuleerd',
    finished: 'Afgerond',
  },
  picklist: {
    lessThanRequestedAmountPickedDialog: {
      title: 'Minder gepakt dan gevraagd',
      description:
        'Je hebt minder producten gepakt dan gevraagd. Weet je zeker dat je door wilt gaan? Zo niet, vergelijk dan het aantal gepakte producten met het verwacht aantal producten.',
    },
    confirmPrintShippingLabelsDialog: {
      title: 'Pakbonnen',
      description:
        'Wil je doorgaan met het downloaden / printen van de pakbonnen voor deze werklijst?',
      buttons: {
        skip: 'Overslaan',
        continue: 'Doorgaan',
      },
    },
    checkingItemsDialog: {
      message: 'Product controleren',
    },
    handleMultipleProductsDialog: {
      title: 'Meerdere producten van dezelfde positie pakken',
    },
    finishedPickingDialog: {
      title: 'Werklijst afgerond',
      description: 'Je hebt de werklijst afgerond.',
    },
    confirmNextActionDialog: {
      title: 'Werklijst afgerond',
      description:
        'De werklijst is afgerond. Wil je doorgaan met het verzenden van de gepakte producten of met het pakken van een andere werklijst?',
      buttons: {
        pack: 'Inpakken',
        keepPicking: 'Werklijsten',
      },
    },
    printingFailedDialog: {
      title: 'Pakbonnen afdrukken mislukt',
      message: 'Het printen van de pakbonnen is mislukt.',
      actions: {
        retry: 'Opnieuw printen',
      },
    },
    printShippingLabelsDialog: {
      description: 'Printen van pakbonnen...',
    },
    confirmAttachmentsReceivedDialog: {
      title: 'Pakbonnen ontvangen',
      description:
        'De pakbonnen zijn geprint of gedownload. Klik op doorgaan om de werklijst af te ronden. Indien je geen pakbonnen hebt ontvangen, klik dan op opnieuw printen en/of controleer je internetverbinding.',
      buttons: {
        retry: 'Opnieuw printen',
        continue: 'Doorgaan',
      },
    },
    requestedAmountPickedDialog: {
      title: 'Gevraagde hoeveelheid gepakt',
      description:
        'Je hebt de gevraagde hoeveelheid van dit product al gepakt. Controleer of je niet te veel hebt gepakt.',
    },
    noParcelQuantityDialog: {
      title: 'Product uit pakket halen',
      description:
        'Je hebt alles van dit product al uit het huidige pakket gehaald. Selecteer een andere pakket om meer van dit product uit de pakketten te halen',
      buttons: {
        changeParcels: 'Pakket selecteren',
      },
    },
    lessThanChangeQuantityDialog: {
      title: 'Product uit pakket halen',
      description:
        'Let op: Het product aantal dat je hebt gewijzigd ligt lager dan wat je van dit product in het huidige pakket hebt liggen. Selecteer een andere pakket om dit product ook uit andere pakketten te halen',
      buttons: {
        changeParcels: 'Pakket selecteren',
      },
    },
    feedback: {
      picklistNotFinished: 'Werklijst kon niet worden afgerond',
    },
  },
  placelist: {
    emptyMessage: 'Geen items meer beschikbaar om weg te leggen.',
    isPlacingItems: 'Producten wegleggen',
    positionDialog: {
      title: 'Positie opgeven',
    },
    unplacedItemsDialog: {
      title: 'Niet-geplaatste producten',
      description:
        'Er staan nog producten op de lijst die nog niet geplaatst zijn. Controleer of je deze producten hebt of klik op afronden.',
    },
    requestedAmountPlacedDialog: {
      title: 'Verwachte aantal weggelegd',
      description:
        'Je hebt het verwachte aantal van dit product al weggelegd. Controleer of de aantallen kloppen.',
    },
    unknownProductDialog: {
      title: 'Product niet gevonden',
      description:
        'Het product wat je hebt gescand staat niet op deze werklijst. Wil je het product aanmelden als te veel ontvangen?',
    },
    feedback: {
      itemAdded: 'Product vermeld als teveel ontvangen',
      itemNotAdded: 'Product kon niet worden vermeld als te veel ontvangen',
      invalidPosition: 'Ongeldige positie',
      placelistNotFinished: 'Werklijst kon niet worden afgerond',
      multipleItemsPlaced: 'Producten zijn weggelegd',
      multipleItemsNotPlaced: 'Producten konden niet worden weggelegd',
    },
  },
  wrongBarcodeDialog: {
    title: 'Verkeerde barcode',
    description:
      'De barcode die je hebt gescand is niet van een van de gevraagde producten. Controleer of je wel het juiste product hebt gepakt.',
    message:
      'De barcode die je hebt gescand is niet van een van de gevraagde producten. Controleer of je wel het juiste product hebt gepakt.',
  },
  pickListTable: {
    actions: {
      addAll: 'Alles gepakt',
      finish: 'Afronden',
    },
  },
  picklistParcel: {
    actions: {
      edit: 'Wijzigen',
    },
  },
  parcelsDialog: {
    title: 'Selecteer een pakket',
    numberOfItems: 'Aantal producten: {count}',
    buttons: {
      close: 'Sluiten',
      createParcel: 'Nieuw pakket',
    },
  },
  putawayList: {
    emptyMessage: 'Geen items beschikbaar',
  },
  putawayHistoryDialog: {
    title: 'Historie',
  },
  handlingListItemDialog: {
    confirmPosition: 'Bevestig positie',
    confirmPositionDialog: {
      title: 'Positie bevestigen',
    },
    differentProductDialog: {
      title: 'Ander product gescand',
      description:
        'De barcode die je hebt gescand is van een ander product. Controleer of je het juiste product hebt gepakt.',
    },
    discardChangesDialog: {
      title: 'Wijzigingen ongedaan maken',
      description:
        'Je hebt al iets van dit product weggelegd. Weet je zeker dat je deze aantallen ongedaan wilt maken?',
    },
    feedback: {
      itemsNotPicked: 'Producten konden niet worden gepakt van positie',
      itemsNotPlaced: 'Producten konden niet worden weggelegd',
      unknownPosition:
        'De ingevulde positie is niet geregistreerd. Verander de positie naar een geregistreerde positie.',
    },
  },
  updateSKUPositionDrawer: {
    title: 'Voorkeurspositie toevoegen',
    feedback: {
      skuPositionUpdated: 'Voorkeurspositie toegevoegd',
      skuPositionNotUpdated: 'Voorkeurspositie kon niet worden toegevoegd',
    },
  },
  files: {
    title: 'Bestanden',
    emptyMessage: 'Nog geen bestanden geupload',
    actions: {
      download: {
        label: 'Downloaden',
      },
      delete: {
        label: 'Verwijderen',
      },
      print: {
        label: 'Printen',
      },
      uploadToStorage: {
        label: 'Uploaden naar',
      },
    },
    confirmDeleteFile: {
      title: 'Bestand verwijderen',
      description: 'Weet je zeker dat je dit bestand wilt verwijderen?',
      buttons: {
        cancel: 'Annuleren',
        delete: 'Verwijderen',
      },
    },
    printingFileFailedDialog: {
      title: 'Printen van bestand mislukt',
      message: 'Het bestand kon niet worden geprint',
    },
    printFileProgressDialog: {
      description: 'Bezig met printen van bestand...',
    },
    feedback: {
      fileDeleted: 'Bestand is verwijderd',
      fileNotDeleted: 'Bestand kon niet worden verwijderd',
      filePrinted: 'Bestand is geprint',
      fileUploaded: 'Bestand geüpload',
      fileNotUploaded: 'Bestand kon niet worden geüpload',
    },
  },
  shipmentStatusses: {
    open: 'Openstaand',
    cancelled: 'Geannuleerd',
    inTransit: 'Onderweg',
    listed: 'Op werklijst',
    finished: 'Afgerond',
    boxed: 'Ingepakt',
    counted: 'Geteld',
    picked: 'Gepakt',
    placed: 'Weggelegd',
  },
  valuePresentation: {
    sku: 'SKU: {sku}',
    ean: 'EAN: {ean}',
  },
  applicationUpdateNotification: {
    updateAvailableMessage: 'Nieuwe versie van de app beschikbaar',
    updateButton: {
      label: 'Bijwerken',
    },
  },
  parcelDialog: {
    feedback: {
      parcelPositionUpdated: 'Pakket positie bijgewerkt',
      parcelPositionNotUpdated: 'Pakket positie kan niet worden bijgewerkt',
    },
  },
  storageUploadDialog: {
    title: 'Bestand uploaden naar',
  },
  ordersSection: {
    title: 'Gerelateerde orders',
  },
  addProductDrawer: {
    title: 'Product toevoegen',
  },
  positionProductList: {
    emptyMessage: 'Geen producten',
  },
  itemQuantityDialog: {
    positionDialog: {
      title: 'Bevestig positie',
    },
  },
  packing: {
    itemQuantityDialog: {
      packTitle: 'Inpakken',
      unpackTitle: 'Uitpakken',
    },
    maxQuantityDialog: {
      packingTitle: 'Items ingepakt',
      packingMessage: 'Je hebt het gevraagde aantal items al ingepakt.',
      unpackingTitle: 'Items uitgepakt',
      unpackingMessage: 'Je hebt het verwachte aantal items al uitgepakt.',
    },
    packingList: {
      emptyMessage: 'Geen items beschikbaar',
    },
    progressDialog: {
      packingMessage: 'Items inpakken',
      unpackingMessage: 'Items uitpakken',
    },
    remainingItemsDialog: {
      title: 'Resterende producten',
      descriptionPacking:
        'Er staan nog producten die nog niet zijn ingepakt. Controleer of je deze producten hebt of klik op afronden.',
      descriptionUnpacking:
        'Er staan nog producten die nog niet zijn uitgepakt. Controleer of je deze producten hebt of klik op afronden.',
    },
    feedback: {
      addItemsToParcelFailed: 'Items konden niet aan het pakket worden toegevoegd',
      multipleItemsPacked: 'Items inpakken',
      multipleItemsNotPacked: 'Items konden niet worden ingepakt',
      multipleItemsUnpacked: 'Items uitpakken',
      multipleItemsNotUnpacked: 'Items konden niet worden uitgepakt',
      parcelNotCreated: 'Pakket kon niet worden aangemaakt',
      parcelDeleted: 'Pakket verwijderd',
      parcelNotDeleted: 'Pakket kon niet worden verwijderd',
      reportMissingItemsRequestFailed: 'Het rapporteren van de ontbrekende items is mislukt',
    },
  },
  confirmPackingActionDialog: {
    title: 'Verzenden of parkeren?',
    description:
      'Deze verzending hoeft niet direct verstuurd te worden. Wil je de verzending toch direct verzenden of wil je de pakketten parkeren?',
  },
  checkParcelsDialog: {
    title: 'Pakketten controleren',
    emptyMessage: 'Geen pakketten beschikbaar',
    numberOfItems: 'Aantal: {count}',
    numberOfParcels: 'Aantal pakketten: {count}',
  },
  itemResultsDialog: {
    title: 'Meerdere items gevonden',
    emptyMessage: 'Geen items gevonden',
  },
  shippingMethodNames: {
    afPickup: 'Afhalen',
  },
  shippingMethodDescriptions: {
    afPickup: 'Afhalen op locatie',
  },
  deleteHandlingListDialog: {
    title: 'Werklijst verwijderen',
    description: 'Weet je zeker dat je deze werklijst wilt verwijderen?',
  },
  cancelShipmentDialog: {
    title: 'Verzending annuleren',
    description: 'Weet je zeker dat je deze verzending wilt annuleren?',
    buttons: {
      cancelShipment: 'Verzending annuleren',
    },
  },
  auditActions: {
    shipmentCreated: 'Verzending aangemaakt',
  },
  auditActors: {
    system: 'Systeem',
  },
  auditCategories: {
    audit: 'Audit',
    request: 'Netwerkverzoek',
    error: 'Fout',
  },
  auditEntities: {
    order: 'Order',
    calculation: 'Offerte',
    invoice: 'Factuur',
    transaction: 'Transactie',
    user: 'Gebruiker',
    dataflow: 'Dataflow',
    contact: 'Contact',
    organisation: 'Organisatie',
    shipment: 'Verzending',
    list: 'Werklijst',
    parcel: 'Pakket',
  },
  properties: {
    name: 'Naam',
    items: 'Items',
    sku: 'SKU',
    locations: 'Locaties',
    expectedAt: 'Verwacht op',
    fromAddress: 'Van',
    toAddress: 'Naar',
    fromLocation: 'Van locatie',
    toLocation: 'Naar locatie',
    shippingMethod: 'Verzendmethode',
    given_name: 'Voornaam',
    givenName: 'Voornaam',
    family_name: 'Achternaam',
    familyName: 'Achternaam',
    additional_name: 'Tussenvoegsel',
    email: 'E-mailadres',
    organisation: 'Organisatie',
    phoneNumber: 'Telefoonnummer',
    country: 'Land',
    premise_number: 'Huisnummer',
    premiseNumber: 'Huisnummer',
    premise_number_suffix: 'Toevoeging',
    thoroughfare: 'Straat',
    locality: 'Plaats',
    postal_code: 'Postcode',
    administrative_area: 'Administratief gebied',
    company: 'Bedrijf',
    searchProduct: 'Product zoeken',
    ean: 'EAN',
    description: 'Omschrijving',
    quantity: 'Aantal',
    expectedQuantity: 'Verwacht',
    boxed: 'Gepakt',
    addAnotherProduct: 'Nog een product toevoegen',
    addAnotherPreferredPosition: 'Nog een voorkeurspositie toevoegen',
    position: 'Positie',
    height: 'Hoogte',
    width: 'Breedte',
    length: 'Lengte',
    weight: 'Gewicht',
    tags: 'Labels',
    trackingCode: 'Track & Trace code',
    trackingUrl: 'Track & Trace URL',
    isPrimary: 'Primair',
    setAsShippingAddress: 'Toevoegen als verzendadres',
    setAsBillingAddress: 'Toevoegen als factuuradres',
    shipments: 'Verzendingen',
    picked: 'Gepakt',
    location: 'Locatie',
    crate: 'Krat',
    inParcel: 'In pakket',
    articleNumber: 'Artikelnr. {number}',
    eanNumber: 'EAN. {number}',
    requested: 'Verwacht',
    received: 'Ontvangen',
    placed: 'Weggelegd',
    place: 'Wegleggen',
    box: 'Doos',
    numberOfItems: 'Aantal items: {number}',
    totalItemCount: 'Aantal items: {count}',
    totalProductCount: 'Aantal producten: {count}',
    yes: 'Ja',
    no: 'Nee',
    isInTransit: 'Is onderweg',
    isFinished: 'Afgerond',
    skus: "Sku's",
    address: 'Adres',
    type: 'Type',
    inbound: 'Inkomend',
    outbound: 'Uitgaand',
    expectedShipAt: 'Verwacht verzenden op',
    shipAt: 'Verzenden op',
    shippingNumber: 'Verzendnummer',
    itemCount: 'Aantal items',
    parcelCount: 'Aantal dozen',
    parcelNumber: 'Pakketnummer',
    parcels: 'Dozen',
    createdAt: 'Aangemaakt op',
    updatedAt: 'Bijgewerkt op',
    postalCode: 'Postcode',
    servicePoint: 'Afhaalpunt',
    shippingAddress: 'Verzendadres',
    shipment: 'Verzending',
    startedAt: 'Gestart op',
    finishedAt: 'Afgerond op',
    dueAt: 'Verwacht op',
    isInProgress: 'In behandeling',
    isOnHold: 'In de wacht',
    isOutbound: 'Uitgaand',
    isServiced: 'Extra service',
    on: 'Aan',
    off: 'Uit',
    to: 'Naar',
    positions: 'Posities',
    pack: 'Inpakken',
    unpack: 'Uitpakken',
    purchaseOrderNumbers: 'Inkoopordernummers',
    path: 'Pad',
    externalStorages: 'Externe opslag',
  },
  errors: {
    validation: {
      addressAlreadyLinkedToLocation:
        'Dit adres is al gekoppeld aan een locatie, kies een ander adres',
      empty: '{target} mag niet leeg zijn',
      integer: '{target} moet een geheel getal zijn',
      maxItems: '{target} mag maximaal {max} items bevatten',
      maxLength: '{target} mag maximaal {max} karakters lang zijn',
      maxNumber: '{target} moet kleiner zijn of gelijk aan {max}',
      minItems: '{target} moet minimaal {min} items bevatten',
      minLength: '{target} moet minstens {min} karakters lang zijn',
      minNumber: '{target} moet minimaal {min} zijn',
      null: '{target} mag niet leeg zijn',
      required: '{target} mag niet leeg zijn',
      unknownPosition:
        'De ingevulde positie is niet geregistreerd, gebruik een geregisteerde positie',
      url: '{target} dient een geldige URL te zijn',
      urlHasProtocol: "{target} dient te beginnen met 'https://' of 'http://'",
      validEmail: 'Vul een geldig e-mail adres in',
      validEmailFormat: 'Vul een geldig e-mail adres in',
      validIBAN: 'Vul een geldig IBAN nummer in',
      atLeastOneNormalCharacter: '{target} mag niet alleen speciale tekens bevatten',
      emailAlreadyUsed: 'E-mailadres al in gebruik',
    },
  },
  fileUpload: {
    labelIdle:
      'Sleep & upload bestanden of <span class="filepond--label-action"> selecteer bestanden </span>',
    labelInvalidField: 'Veld bevat niet ondersteunde bestanden',
    labelFileWaitingForSize: 'Wachten op bestandsgrootte',
    labelFileSizeNotAvailable: 'Bestandsgrootte niet beschikbaar',
    labelFileLoading: 'Aan het laden',
    labelFileLoadError: 'Fout opgetreden tijdens het laden',
    labelFileProcessing: 'Bezig met uploaden',
    labelFileProcessingComplete: 'Upload voltooid',
    labelFileProcessingAborted: 'Upload geannuleerd',
    labelFileProcessingError: 'Fout opgetreden tijdens het uploaden',
    labelFileProcessingRevertError: 'Fout opgetreden tijdens het ongedaan maken',
    labelFileRemoveError: 'Fout opgetreden tijdens het verwijderen',
    labelTapToCancel: 'Tik om te annuleren',
    labelTapToRetry: 'Tik om opnieuw te proberen',
    labelTapToUndo: 'Tik om ongedaan te maken',
    labelButtonRemoveItem: 'Verwijderen',
    labelButtonAbortItemLoad: 'Afbreken',
    labelButtonRetryItemLoad: 'Opnieuw',
    labelButtonAbortItemProcessing: 'Annuleren',
    labelButtonUndoItemProcessing: 'Ongedaan maken',
    labelButtonRetryItemProcessing: 'Opnieuw',
    labelButtonProcessItem: 'Upload',
    labelMaxFileSize: 'Maximale bestandsgroote is {filesize}',
    labelMaxTotalFileSize: 'Maximale totale bestandsgroote is {filesize}',
    labelMaxFileSizeExceeded: 'Maximale bestandsgroote overschreden',
    labelMaxTotalFileSizeExceeded: 'Maximale totale bestandsgroote overschreden',
    labelFileTypeNotAllowed: 'Bestandstype niet toegestaan',
    fileValidateTypeLabelExpectedTypes: 'Verwacht bestandstype {allTypes}',
    duplicateFileDialog: {
      title: 'Bestand bestaat al',
      description: 'Er bestaat al een bestand met de naam "{filename}" in deze folder',
      buttons: {
        cancel: 'Annuleren',
        resolve: 'Automatisch hernoemen',
        upsert: 'Overschrijven',
      },
    },
  },
  datePicker: {
    datePlaceholder: 'dd/mm/jjjj',
    dateTimePlaceholder: 'dd/mm/jjjj uu:mm',
    timePlaceholder: 'uu:mm',
    cancelLabel: 'ANNULEREN',
    clearLabel: 'LEGEN',
    okLabel: 'OK',
    todayLabel: 'VANDAAG',
    toolbarTitle: 'SLECTEER EEN DATUM',
  },
  shippingMethodFormSection: {
    title: 'Verzendmethode',
  },
  orderTypeOptions: {
    order: 'Order',
    purchase: 'Inkoop',
    cancellation: 'Annulering',
    return: 'Retour',
  },
  components: {
    autocomplete: {
      clearText: 'Legen',
      loadingText: 'Laden...',
      noOptionsText: 'Geen opties',
      openText: 'Open',
    },
    dataflowDrawer: {
      title: 'Dataflows',
      feedback: {
        dataFlowFinished: 'Dataflow is afgerond',
        dataFlowFailed: 'Er is iets mis gegaan tijdens het uitvoeren van de dataflow',
        dataFlowUnmatched: 'Voor deze dataflow wordt niet aan de juiste voorwaarden voldaan',
        noDataflows: 'Geen dataflows gevonden',
      },
    },
    addressForm: {
      fields: {
        organisation: {
          helpText: {
            sendCloudWarning:
              'Om fouten te voorkomen met SendCloud raden we aan niet meer dan 35 tekens te gebruiken in dit veld, op dit moment {length}',
          },
        },
      },
    },
  },
  sessionErrorDialog: {
    title: 'Ongeldige sessie',
    description:
      'Je sessie is verlopen of er heeft een fout plaats gevonden. Log opnieuw in om door te gaan met je sessie.',
    supportDescription:
      'Indien je deze melding direct weer te zien krijgt nadat je opnieuw bent ingelogd. Neem dan contact op met Afosto support.',
    actions: {
      loginAgain: 'Opnieuw inloggen',
    },
  },
};

export default translations;
